import { styled } from '@lessonup/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFeatureFlags } from '../../../utils/featureFlags/useFeatureFlags';
import { i18nextNamespaceAiTools } from '../AiToolbox.utils';

export const MissingFlagHelper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isFeatureEnabled, loading } = useFeatureFlags();

  // do not show the missing flag banner while loading so it does not flash
  if (loading) {
    return null;
  }

  if (!isFeatureEnabled('aiToolboxOverview')) {
    return <MissingFlagBanner />;
  }

  return <>{children}</>;
};

const MissingFlagBanner = () => {
  const { t } = useTranslation(i18nextNamespaceAiTools);

  return (
    <Wrapper>
      <p>{t('missingFeatureFlagMessage')}</p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
`;
